import { useMenu } from './useMenu';
import { BoxArrowRight, PersonCircle } from 'react-bootstrap-icons';
import Button from 'react-bootstrap/Button';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { LinkContainer } from 'react-router-bootstrap';
import Container from 'react-bootstrap/Container';

export const Menu = () => {
    const { menu, accountLink, onClickLogout } = useMenu();

    return (
        <Navbar expand="lg" bg="dark" variant="dark" className="mb-3">
            <Container>
                <Navbar.Brand>Record</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav>
                        {menu.map(item => (
                            <LinkContainer to={item.link} key={item.label}>
                                <Nav.Link>{item.label}</Nav.Link>
                            </LinkContainer>
                        ))}
                    </Nav>
                </Navbar.Collapse>
                {accountLink ? (
                    <>
                        <Navbar.Brand>
                            <LinkContainer to={accountLink}>
                                <Nav.Link>
                                    <PersonCircle/>
                                </Nav.Link>
                            </LinkContainer>
                        </Navbar.Brand>
                        <Navbar.Brand>
                            <Button variant="dark" onClick={onClickLogout}>
                                <BoxArrowRight/>
                            </Button>
                        </Navbar.Brand>

                    </>
                ) : null}
            </Container>
        </Navbar>
    );
};
